export default "__VITE_ASSET__DljIjC13__"